<template>
  <section class="table">
    <table>
      <tbody>
      <tr>
        <th colspan="3">Стоимость технического обслуживания</th>
      </tr>
      <tr>
        <th>Модель</th>
        <th>Мощность, кВт.</th>
        <th>Цена, руб.</th>
      </tr>
      <tr>
        <td>навесной витопенд</td>
        <td>24-35</td>
        <td>от 6 500</td>
      </tr>
      <tr>
        <td rowspan="2">навесной витоденс</td>
        <td>24-100</td>
        <td>от 11 500</td>
      </tr>
      <tr>
        <td>100-150</td>
        <td>от 14000</td>
      </tr>
      <tr>
        <td rowspan="3">напольный витогаз</td>
        <td>29-60</td>
        <td>от 9 500</td>
      </tr>
      <tr>
        <td>72-96</td>
        <td>от 11 500</td>
      </tr>
      <tr>
        <td>108-140</td>
        <td>от 14 000</td>
      </tr>
      <tr>
        <td>напольный витокроссал</td>
        <td>-</td>
        <td>от 14 000</td>
      </tr>
      <tr>
        <td rowspan="2">напольный виторонд</td>
        <td>35-100</td>
        <td>от 11 500</td>
      </tr>
      <tr>
        <td>100-200</td>
        <td>от 14 000</td>
      </tr>
      <tr>
        <td>напольный витоплекс</td>
        <td>до 275</td>
        <td>от 14 000</td>
      </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>